


















import Vue from 'vue';
import { TipoAttributo } from '../../types';
import validationRules from '../mixin/validation-rules';

export default Vue.extend({
    data() {
        return {
            items: [] as TipoAttributo[],
            selectedValue: null as any,
            disabled: false as boolean,
        };
    },
    props: {
        label: { type: String },
        clearable: { default: false },
        setDefault: { default: false },
        value: {},
        required: { default: false },
    },
    computed: {
        validationRules(): any[] {
            return this.required
                ? [validationRules.getRequiredRule(this.label)]
                : [];
        },
    },
    methods: {
        onChange(e: any) {
            this.$emit('input', e);
        },
        loadItems() {
            const items = [
                {
                    id: 'Provincia',
                },
                {
                    id: 'Professione',
                },
                {
                    id: 'OperatoreSanitarioQualifica',
                },
                {
                    id: 'TipoDocumento',
                },
                {
                    id: 'Sesso',
                },
                {
                    id: 'ProcedimentoCivile',
                },
                {
                    id: 'DannoLamentato',
                },
                {
                    id: 'TipoIncarico',
                },
                {
                    id: 'TipoRelazione',
                },
                {
                    id: 'EsameObiettivo',
                },
                {
                    id: 'ContestazioniControparte',
                },
                {
                    id: 'SintesiCriticita',
                },
                {
                    id: 'ConsiderazioniMedicoLegali',
                },
            ] as TipoAttributo[];
            for (const item of items) {
                item.displayName = Vue.filter('tipoAttributo')(item.id);
            }
            this.items = items.sort((a, b) => {
                return a.displayName > b.displayName ? 1 : -1;
            });
            if (
                this.setDefault &&
                this.items.length > 0 &&
                !this.selectedValue
            ) {
                this.selectedValue = this.items[0].id;
                this.onChange(this.selectedValue);
            }
            if (
                this.items.filter((item) => item.id === this.selectedValue)
                    .length === 0
            ) {
                this.selectedValue = null;
                this.onChange(this.selectedValue);
            }
            this.disabled = false;
        },
    },

    watch: {
        value: {
            handler: function (val) {
                if (val || !this.setDefault) {
                    this.selectedValue = val;
                }
                this.onChange(this.selectedValue);
            },
            immediate: true,
        },
    },
    mounted() {
        this.loadItems();
    },
});
